import React from "react";
import { Route, Switch } from 'react-router-dom';
import { Archiviazione } from '../../archiviazione';
import ToContributiInScadenza from './ToContributiInScadenza';
import { InScadenza } from '../../contributi';
import PageNotFound from './PageNotFound';
import AnagraficaRoute from "./AnagraficaRoute";

export default class Routes extends React.Component {
    render() {
        return (
            <Switch>
                <AnagraficaRoute path="/" exact component={ToContributiInScadenza} />
                <AnagraficaRoute path="/contributi" component={InScadenza} />
                <AnagraficaRoute path="/archiviazione" component={Archiviazione} />

                <Route component={PageNotFound} />
            </Switch>
        );
    }
}